import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Form from "deltoid/core/Form";
import { useForm } from "react-hook-form";
import { Row } from "deltoid/core/Blocks/BootstrapContainers";
import Mustache from 'mustache';

import FormFooter from '@components/BaseComponents/FormFooter';
import Dialog from "@components/ManualUpload/Dialog";
import { DOCUMENT_CHECKLIST } from "@constants/manualUploadConstants";
import { uiActions, dialogActions, merchantSelectors, manualUploadActions, manualUploadSelectors } from "@store/ducks";
import capitalize from "lodash/capitalize";
import UploadItem from "./UploadItem";
import { MERCHANT_DOC_STATUS } from "../../constants/manualUploadConstants";

const AdditionalUploadForm = ({
  document_details,
  signing_authority_details,
  fetchDocumentDetails,
  dialogOnClose,
  verifyDocumentStatus,
  editable,
  why,
  document_status,
}) => {
  const { handleSubmit } = useForm({
    mode: "onBlur",
  });
  useEffect(() => {
    fetchDocumentDetails();
  }, []);

  const { business_entity, document_categories } = document_details;

  let signatory_authority_name = signing_authority_details?.[0]?.name || 'Signatory Authority';

  const UploadItems = document_categories.map((category) => {
    let {
      docCategoryLabel: categoryLabel = category.name,
      fileCount = "single",
      maxFileSizeLimit = 5,
    } = DOCUMENT_CHECKLIST[business_entity]?.[category.name_on_frontend] || {};

    categoryLabel = Mustache.render(categoryLabel, { signatory_authority_name });

    const multiple =
      fileCount === "single" ? false : fileCount === "uploadFrontAndBack" || fileCount === "multiple" ? true : false;

    const docTypes = multiple
      ? DOCUMENT_CHECKLIST[business_entity]
        ? DOCUMENT_CHECKLIST[business_entity][category.name_on_frontend].docTypes
        : []
      : [];

    return (
      <UploadItem
        key={category.name_on_frontend}
        category={category}
        categoryLabel={categoryLabel}
        subCategories={category.document_types.map(({ id, name, uuid, name_on_frontend }) => ({
          label: name,
          value: name,
          id: id,
          uuid: uuid,
          name_on_frontend: name_on_frontend,
        }))}
        multiple={multiple}
        fileCount={fileCount}
        docTypes={docTypes}
        maxFileSizeLimit={maxFileSizeLimit}
        uploadedDocument={category.kyc_document}
      />
    );
  });

  const onSubmit = (formData) => {
    if (editable)
      verifyDocumentStatus();
  };

  return (
    <>
      <Dialog onClose={dialogOnClose} />
      <div className='px-4'>
        {UploadItems}
        {
          !document_categories.length &&
          <Form.Message className="no-addition-docs">
            Congratulations, your KYC is complete We do not need any additional documents at the moment.
          </Form.Message>
        }
      </div>
      {
        document_status !== MERCHANT_DOC_STATUS.DOCUMENT_APPROVED && (editable && document_categories.length > 0 &&
          <FormFooter
            tooltipProps={why}
            btnProps={{
              label: 'Submit Documents',
              type: "button",
              onClick: onSubmit,
            }}
          />
        )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
  fetchDocumentDetails: () => dispatch(manualUploadActions.fetch()),
  dialogOnClose: () => dispatch(dialogActions.close()),
  verifyDocumentStatus: () => dispatch(manualUploadActions.verifyDocumentStatus()),
});
const mapStateToProps = (state) => {
  return {
    signing_authority_details: merchantSelectors.getSigningAuthorityDetails(state),
    document_details: manualUploadSelectors.getDocumentDetails(state),
    document_status: merchantSelectors.getDocumentStatus(state),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AdditionalUploadForm);
